import { render, staticRenderFns } from "./erm_dashboard_help.vue?vue&type=template&id=a99294d2&scoped=true&"
import script from "./erm_dashboard_help.vue?vue&type=script&lang=js&"
export * from "./erm_dashboard_help.vue?vue&type=script&lang=js&"
import style0 from "./erm_dashboard_help.vue?vue&type=style&index=0&id=a99294d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99294d2",
  null
  
)

export default component.exports